'use client'

// import Link from "next/link"
// import { usePathname } from "next/navigation"
import {
  Breadcrumb,
  BreadcrumbList,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbSeparator,
  BreadcrumbPage,
} from 'components/ui/breadcrumb'
import { Link, useLocation } from 'react-router-dom'

interface ProjectBreadcrumbsProps {
  projectTitle?: string
  className?: string
}

export function ProjectBreadcrumbs({
  projectTitle,
  className,
}: ProjectBreadcrumbsProps) {
  const location = useLocation()
  const segments = location.pathname.split('/').filter(Boolean)

  const isProjectDetailsPage =
    segments.length === 2 && segments[0] === 'projects'
  const filteredSegments = isProjectDetailsPage ? [segments[1]] : segments

  return (
    <div
      className={`py-4 px-4 md:px-8 border-b border-gray-100 bg-neutral-50 border-none ${
        className || ''
      }`}
    >
      <div className="mx-auto max-w-6xl">
        <Breadcrumb>
          <BreadcrumbList className="pl-4">
            <BreadcrumbItem>
              <BreadcrumbLink asChild>
                <Link to="/deals">Home</Link>
              </BreadcrumbLink>
            </BreadcrumbItem>

            {filteredSegments.length > 0 && (
              <>
                <BreadcrumbSeparator />
                <BreadcrumbItem>
                  {filteredSegments.length === 1 ? (
                    <BreadcrumbPage>
                      {isProjectDetailsPage
                        ? projectTitle ||
                          filteredSegments[0]
                            .split('-')
                            .map(
                              (word) =>
                                word.charAt(0).toUpperCase() + word.slice(1),
                            )
                            .join(' ')
                        : filteredSegments[0].charAt(0).toUpperCase() +
                          filteredSegments[0].slice(1)}
                    </BreadcrumbPage>
                  ) : (
                    <BreadcrumbLink asChild>
                      <Link to={`/${filteredSegments[0]}`}>
                        {filteredSegments[0].charAt(0).toUpperCase() +
                          filteredSegments[0].slice(1)}
                      </Link>
                    </BreadcrumbLink>
                  )}
                </BreadcrumbItem>
              </>
            )}

            {filteredSegments.length > 1 && (
              <>
                <BreadcrumbSeparator />
                <BreadcrumbItem>
                  <BreadcrumbPage>
                    {projectTitle ||
                      filteredSegments[1]
                        .split('-')
                        .map(
                          (word) =>
                            word.charAt(0).toUpperCase() + word.slice(1),
                        )
                        .join(' ')}
                  </BreadcrumbPage>
                </BreadcrumbItem>
              </>
            )}
          </BreadcrumbList>
        </Breadcrumb>
      </div>
    </div>
  )
}
